export default __webpack_public_path__ + "static/media/mar-progress.1a5f1be9.png";